import { Disclaimer } from '@stodge-inc/block-rendering';
import { api } from 'controllers/network/apiClient';

const DISCLAIMER_BASE_URL = '/sdk/config';

export const getDisclaimerText = async (
  shopId: number,
): Promise<Disclaimer> => {
  const result = await api.get(`${DISCLAIMER_BASE_URL}?shop_id=${shopId}`);
  const disclaimer = result?.data?.disclaimer;

  if (!disclaimer) {
    throw new Error('Disclaimer data not found');
  }

  return disclaimer;
};
